export default {"src":"/_next/static/media/tooth_24.c59b758a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};